module.exports = __webpack_public_path__ + "img/库尔_新加坡.d832b88e.webp";